import { flow, makeObservable, observable } from 'mobx';
import { CoursePlanApi } from '../apis';
import BaseStore from './BaseStore';

class CoursePlanStore extends BaseStore {

    constructor(rootStore) {
        super();
        makeObservable(this, {
            createCoursePlan: flow.bound,
            deleteCoursePlan: flow.bound
        })
        this.rootStore = rootStore;
        this.api = new CoursePlanApi();
    }

    *createCoursePlan(payload) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.createCoursePlan, payload);
            if(res?.ok) {
                return true;
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }

    *deleteCoursePlan(id) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.deleteCoursePlan, { id });
            if(res?.ok) {
                return true;
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }
}

export default CoursePlanStore;